module.exports = __webpack_public_path__ + "img/client-kofemolka.fc3668b3.png";